import { Injectable } from "@angular/core";
import { FeatureToggleClientService } from "@schwab/schwab-feature-toggle-angular";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  featureServiceReady$!: Observable<boolean>;

  public featureFlags: { [key: string]: boolean } = {
    isMdsSymbolSearchEnabled: false
  }

  constructor(private readonly featureService: FeatureToggleClientService) { }

  initializeFeatureFlags(): Promise<void> {
    this.featureServiceReady$ = this.featureService.monitorReadiness();
    return Promise.resolve();
  }
}
